import React from 'react';
import { McModal } from '@maersk-global/mds-react-wrapper/mc-modal';
import { McButton } from '@maersk-global/mds-react-wrapper/components-core/mc-button';
import { McInput } from '@maersk-global/mds-react-wrapper/components-core/mc-input';

const EditSlaModal = ({
  open,
  onClose,
  currentTargetSla,
  newTargetSla,
  onChangeNewTargetSla,
  onSubmit,
  loading = false,
}) => {
  return (
    <McModal
      heading="Edit Target SLA"
      closed={onClose}
      open={open}
      width="40vw"
      height="40vh"
    >
      <div style={{ padding: '16px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <div>
          <label style={{ fontSize: '12px', fontWeight: 600, display: 'block', marginBottom: '4px' }}>Current Target SLA</label>
          <div style={{ fontSize: '14px', background: '#f5f5f5', border: '1px solid #ddd', padding: '8px', borderRadius: '4px' }}>
            {currentTargetSla || '—'}
          </div>
        </div>
        <div>
          <label htmlFor="new-target-sla" style={{ fontSize: '12px', fontWeight: 600, display: 'block', marginBottom: '4px' }}>New Target SLA</label>
          <McInput
            id="new-target-sla"
            hiddenlabel="true"
            placeholder="Enter new target SLA (e.g., 24 hrs)"
            value={newTargetSla}
            onChange={onChangeNewTargetSla}
            disabled={loading}
          />
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
          <McButton appearance="secondary" label="Cancel" click={onClose} disabled={loading} />
          <McButton appearance="primary" label="Submit" click={onSubmit} disabled={loading || !newTargetSla} />
        </div>
      </div>
    </McModal>
  );
};

export default EditSlaModal;
